import React, { Component } from 'react'
import './Obhodnoilist.css'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import './SpravkaObObuch.css'
import QRCode from 'qrcode.react';

export default class SpravkaObObuch extends Component {
    constructor(props) {
        super(props)
        var today = new Date(),
            date = today.getDate() + '.' + (today.getMonth().length < 8 ? '0' : '') + (today.getMonth() + 1) + '.' + today.getFullYear();
        // datetime = (today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds())
        this.state = {
            // currentDateTime: datetime,
            currentDate: date,
        }
    }

    OpenReportsPage(reportsPage, reportType) {
        this.props.OpenReportsPage(reportsPage, reportType)
    }
    selectLanguage(language) {
        this.props.selectLanguage(language)
    }

    render() {
        const { Studing } = this.props
        // console.log("Studing", Studing)
        return (
            <div className='ObhodnoiList D_main_header' >
                <header>
                    <i className="fas fa-arrow-left" onClick={() => this.OpenReportsPage(0, 0)}></i>
                    <ReactToPrint content={() => this.componentRef}>
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <i onClick={handlePrint} className="fa fa-print" title="Печать"></i>
                            )}

                        </PrintContextConsumer>
                    </ReactToPrint>
                    {this.props.language === 1 ? <h2> Справка об обучении</h2> : <h2> Справка об обучении</h2>}
                    {/* <div className='Language'>
                        <h4 onClick={() => this.selectLanguage(1)} className={this.props.language === 1 ? 'Lang_Active' : 'Lang'}>Рус</h4>
                        <h4 onClick={() => this.selectLanguage(2)} className={this.props.language === 2 ? 'Lang_Active' : 'Lang'}>Кырг</h4>
                    </div> */}
                </header>

                <div className="A4 SpravkaObObuch" ref={el => (this.componentRef = el)}>
                    <h3>{Studing && Studing.length && Studing[0].length && Studing[0][0].mo}</h3>
                    <h3>{Studing && Studing.length && Studing[0].length && Studing[0][0].v2}</h3>
                    <h4>{Studing && Studing.length && Studing[0].length && Studing[0][0].faculty}</h4>
                    <h1>{`СПРАВКА № 2-${this.props.id_group}-${this.props.id_student}-${this.props.DefSem}`}</h1>
                    <p style={{ marginTop: '15px' }}>Настоящая справка подтверждает то, что</p>
                    <h5>{Studing && Studing.length && Studing[1].length && Studing[1][0].s_fio}</h5>
                    <p>
                        {`действительно является ${Studing && Studing.length && Studing[1].length && Studing[1][0].Male == 1 ? 'студентом' : 'студенткой'} ${Studing && Studing.length && Studing[1].length && Studing[1][0].id_rate}-курса группы 
                        ${Studing && Studing.length && Studing[1].length && Studing[1][0].p20}
                        ${Studing && Studing.length && Studing[1].length && Studing[1][0].p108.includes('бакалавр') ? 'направлении ' : 'специальности '}   
                        "${Studing && Studing.length && Studing[1].length && Studing[1][0].p108.includes('бакалавр') ? Studing && Studing.length && Studing[2].length && Studing[2][0].direction : Studing && Studing.length && Studing[2].length && Studing[2][0].special}
                        (${Studing && Studing.length && Studing[1].length && Studing[1][0].p108})".`}
                    </p>
                    <p style={{ marginTop: '24px', textAlign: 'left', padding: '0 110px' }}>
                        {`Общий срок обучения: ${Studing && Studing.length && Studing[2].length && Studing[2][0].max_rate_id} ${Studing && Studing.length && Studing[2].length && Studing[2][0].max_rate_id > 4 ? 'лет' : 'года'}.`}
                    </p>
                    <p style={{ marginTop: '26px' }}>Справка выдана по месту требования.</p>
                    <div className="podpisi">
                        <div>
                            <QRCode
                                id="qrCodeEl"
                                value={`${this.state.currentDate}:${this.props.id_a_year}${this.props.id_rate}${this.props.id_group}${this.props.id_student}`} />
                            <h5>{this.state.currentDate} г., {this.props.user_fio}
                                {/* {this.props.doljnost} */}
                            </h5>
                        </div>
                        <div>
                            <h4 >{Studing && Studing.length && Studing[3].length && Studing[3][0].insert_pole}</h4>
                            <h4 >{Studing && Studing.length && Studing[4].length && Studing[4][0].insert_pole}</h4>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}


